import { useDispatch, useSelector } from "react-redux";
import {
  CreateTradingAccountReq,
  UserSearchReq,
  getUserList,
  getUserProfileData,
} from "../../../utils/api/apis";
import "./style.scss";
import Select from "react-select";
import { useEffect, useState, useMemo } from "react";
import { returnErrors } from "../../../store/reducers/error";
import { returnMessages } from "../../../store/reducers/message";
import { CircularProgress } from "@mui/material";
import { country } from "../../../utils/constants/country";
import { esAR } from "rsuite/esm/locales";
export const customStyles = {
  control: (provided) => ({
    ...provided,
    background: "none",
    width: "100%",
    marginTop: "0px",
    height: 60,
    borderRadius: 8,
    border: "1px solid #eaf0f8;",
    boxShadow: "none",
    fontFamily: "DM Sans, sans-serif",
    fontSize: "14px",
    fontWeight: 700,
    minHeight: "48px",
    height: "48px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "grey",
    fontSize: "14px",
    fontWeight: 500,
    textTransform: "capitalize",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: "48px",
    padding: "0 6px",
    fontWeight: 500,
    marginLeft: "10px",
    color: "#000",
  }),
  input: (provided, state) => ({
    ...provided,
    margin: "0px",
    color: "#000",
  }),
  indicatorSeparator: (state) => ({
    display: "none",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "48px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#000",
    fontWeight: 500,
    textTransform: "capitalize",
  }),
  option: (provided, state) => ({
    ...provided,
    textTransform: "capitalize",
  }),
};

const getCountryIdentifiers = (userCountry, selectedCountryObj) => {
  const rawList = [
    userCountry,
    selectedCountryObj?.country,
    selectedCountryObj?.iso,
  ].filter(Boolean);

  const ids = new Set();
  rawList.forEach((val) => {
    if (typeof val === "string") {
      const trimmed = val.trim().toLowerCase();
      ids.add(trimmed);
      ids.add(trimmed.replace(/[^a-z0-9]/g, ""));
    }
  });
  return Array.from(ids);
};

const isPolandCountry = (userCountry, selectedCountryObj) => {
  const ids = getCountryIdentifiers(userCountry, selectedCountryObj);
  return ids.some(
    (id) => id === "poland" || id === "pl" || id === "pol",
  );
};

const isMatchTraderOnlyCountry = (userCountry, selectedCountryObj) => {
  const ids = getCountryIdentifiers(userCountry, selectedCountryObj);
  if (ids.length === 0) return false;

  // Canada
  if (ids.some((id) => id === "canada" || id === "ca" || id === "can")) {
    return true;
  }
  // Crimea
  if (ids.some((id) => id.includes("crimea"))) {
    return true;
  }
  // Cuba
  if (ids.some((id) => id === "cuba" || id === "cu" || id === "cub")) {
    return true;
  }
  // Iran
  if (ids.some((id) => id === "ir" || id === "irn" || id.includes("iran"))) {
    return true;
  }
  // North Korea
  if (
    ids.some(
      (id) =>
        id === "kp" ||
        id === "prk" ||
        id === "dprk" ||
        id === "north korea" ||
        id === "northkorea" ||
        (id.includes("korea") && (id.includes("north") || id.includes("democratic"))),
    )
  ) {
    return true;
  }
  // Sudan (excluding South Sudan)
  const isSouthSudan = ids.some(
    (id) => id === "ss" || id === "ssd" || id.includes("south sudan") || id.includes("southsudan"),
  );
  if (!isSouthSudan) {
    if (
      ids.some(
        (id) =>
          id === "sd" ||
          id === "sdn" ||
          id === "sudan" ||
          id === "the sudan" ||
          id === "thesudan" ||
          id === "republic of the sudan" ||
          id === "republicofthesudan",
      )
    ) {
      return true;
    }
  }
  // Syria
  if (ids.some((id) => id === "sy" || id === "syr" || id.includes("syria"))) {
    return true;
  }
  // USA
  if (
    ids.some(
      (id) =>
        id === "us" ||
        id === "usa" ||
        id === "united states" ||
        id === "unitedstates" ||
        id === "united states of america" ||
        id === "unitedstatesofamerica" ||
        id === "u.s." ||
        id === "u.s.a.",
    )
  ) {
    return true;
  }
  return false;
};

const CreateTradingAccount = () => {
  const [emailOpts, setEmailOpts] = useState([{ label: "", value: "" }]);
  const [userEmail, setUserEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();

  const [userCountry, setUserCountry] = useState(null);
  const [isCountryLoading, setIsCountryLoading] = useState(false);

  const selectedCountryObj = country?.find(
    (c) =>
      c?.country === userCountry ||
      c?.iso === userCountry ||
      c?.country?.toLowerCase() === userCountry?.toLowerCase() ||
      c?.iso?.toLowerCase() === userCountry?.toLowerCase()
  );

  // User search by email
  const fetch = async (value) => {
    setIsLoading(true);
    const response = await UserSearchReq(idToken, value);
    setIsLoading(false);
    if (response?.status < 399 && Array.isArray(response?.data)) {
      let userArray = [];
      response.data.map((item) =>
        userArray.push({
          label: item?.email,
          value: item?.id,
          country: item?.country,
        }),
      );

      setEmailOpts(userArray);

      // Pre-fetch country if only 1 user returned from search
      if (userArray.length === 1 && userArray[0]?.label) {
        getUserProfileData(idToken, userArray[0].label)
          .then((profileRes) => {
            if (profileRes?.status < 399 && profileRes?.data?.country) {
              userArray[0].country = profileRes.data.country;
              setEmailOpts([...userArray]);
              if (data?.user === userArray[0].value) {
                setUserCountry(profileRes.data.country);
              }
            }
          })
          .catch(() => {});
      }
    } else {
      if (response?.response?.data?.message) {
        return;
      }
      let msg = response?.response?.data?.detail || "Something went wrong";
      dispatch(returnErrors(msg, 400));
    }
  };

  const handleUserChange = async (selectedOption) => {
    setUserEmail(selectedOption ? selectedOption.label : "");
    setData((prev) => ({
      ...prev,
      user: selectedOption ? selectedOption.value : null,
    }));

    if (!selectedOption || !selectedOption.label) {
      setUserCountry(null);
      return;
    }

    if (
      selectedOption.country !== undefined &&
      selectedOption.country !== null &&
      selectedOption.country !== ""
    ) {
      setUserCountry(selectedOption.country);
      return;
    }

    // Call user profile API to get user country
    setIsCountryLoading(true);
    try {
      const profileRes = await getUserProfileData(idToken, selectedOption.label);
      if (profileRes?.status < 399 && profileRes?.data?.country) {
        setUserCountry(profileRes.data.country);
        return;
      }

      // Fallback to getUserList to fetch user country as per User List
      const response = await getUserList(idToken, {
        search: selectedOption.label,
        page: 1,
        page_size: 10,
      });
      if (response?.status < 399 && response?.data?.results) {
        const found = response.data.results.find(
          (item) =>
            item?.id === selectedOption.value ||
            item?.email?.toLowerCase() === selectedOption.label?.toLowerCase(),
        );
        const countryVal =
          found ? found.country : response.data.results[0]?.country;
        setUserCountry(countryVal || null);
      } else {
        setUserCountry(null);
      }
    } catch (error) {
      console.error("Error fetching user country:", error);
      setUserCountry(null);
    } finally {
      setIsCountryLoading(false);
    }
  };

  // create trading account req
  const fundingData = useSelector((state) => state.funding.fundingData);
  const [planOptions, setPlanOptions] = useState([]);
  const [competitonOptions, setCompetitionOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedCompetition, setSelectedCompetition] = useState(null);
  const [phase, setPhase] = useState(null);
  const [isSpinner, setIsSpinner] = useState(false);
  const { selectedBrand } = useSelector((state) => state.brand);

  const [selectedIssueType, setSelectedIssueType] = useState(null);

  const issueTypeOptions = [
    { value: "Affiliate", label: "Affiliate" },
    { value: "BOGO", label: "BOGO" },
    { value: "Giveaway", label: "Giveaway" },
    { value: "Retry", label: "Retry" },
    { value: "Test", label: "Test" },
    { value: "Other", label: "Other" },
  ];

  const phaseOptions = [
    ...(selectedOption?.label?.toLowerCase().includes("pro edge")
      ? [{ label: "Pro edge", value: "pro_edge" }]
      : selectedOption?.label?.toLowerCase().includes("instant")
        ? [{ label: "Instant", value: "pro_edge" }]
        : [
            // { label: "Free", value: "free_trial" },
            { label: "Stage 1", value: "stage_1" },
            { label: "Stage 2", value: "stage_2" },
            { label: "Funded", value: "funded" },
          ]),
  ];

  const phaseCryptoOptions = [
    ...([16, 17].includes(selectedOption?.value)
      ? [{ label: "Stage 1", value: "stage_1" }]
      : []),

    ...([17].includes(selectedOption?.value)
      ? [{ label: "Stage 2", value: "stage_2" }]
      : []),
    ...([18, 17, 16].includes(selectedOption?.value)
      ? [{ label: "Funded", value: "funded" }]
      : []),
  ];
  const isMt5Only = useMemo(
    () => isPolandCountry(userCountry, selectedCountryObj),
    [userCountry, selectedCountryObj],
  );

  const isMatchTraderOnly = useMemo(
    () => isMatchTraderOnlyCountry(userCountry, selectedCountryObj),
    [userCountry, selectedCountryObj],
  );

  const brokerOptions = useMemo(() => {
    if (selectedBrand?.brand !== "equity_edge") {
      return [{ label: "CE Terminal", value: "ce_terminal" }];
    }
    if (isMt5Only) {
      return [{ label: "MT5", value: "mt5" }];
    }
    if (isMatchTraderOnly) {
      return [{ label: "Match-Trader", value: "matchtrade" }];
    }
    return [
      { label: "Match-Trader", value: "matchtrade" },
      { label: "MT5", value: "mt5" },
    ];
  }, [selectedBrand?.brand, isMt5Only, isMatchTraderOnly]);

  const [data, setData] = useState(
    selectedBrand?.brand === "equity_edge"
      ? { broker: "matchtrade" }
      : { broker: "ce_terminal" },
  );
  const [broker, setBroker] = useState(brokerOptions[0]);

  useEffect(() => {
    if (brokerOptions.length > 0) {
      const isCurrentBrokerValid = brokerOptions.some(
        (b) => b?.value === broker?.value,
      );
      if (!isCurrentBrokerValid) {
        const nextBroker = brokerOptions[0];
        setBroker(nextBroker);
        setData((prev) => {
          const { challenge, phase, ...rest } = prev;
          return {
            ...rest,
            broker: nextBroker.value,
          };
        });
        setSelectedOption(null);
        setSelectedCompetition(null);
        setPhase(null);
      }
    }
  }, [brokerOptions, broker]);

  // use Effects
  console.log(selectedOption, "selectedOptionselectedOption");

  const handleSelectChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setSelectedCompetition(null);

    setData((prev) => {
      const { challenge, phase, ...rest } = prev;

      if (selectedOption?.label?.toLowerCase().includes("pro edge")) {
        setPhase({ label: "Pro edge", value: "pro_edge" });
        return {
          ...rest,
          phase: "pro_edge",
        };
      } else if (selectedOption?.label?.toLowerCase().includes("instant")) {
        setPhase({ label: "Instant", value: "pro_edge" });
        return {
          ...rest,
          phase: "pro_edge",
        };
      } else {
        setPhase(null);
        return rest;
      }
    });
  };
  // Update phaseOptions

  console.log("selectedCompetition", selectedCompetition);

  const handleSelectCompetitionChange = (selectedOption) => {
    setSelectedCompetition(selectedOption);
  };
  useEffect(() => {
    let planArray = [];
    fundingData &&
      fundingData.forEach((item) => {
        planArray.push({ value: item.id, label: item.name });
      });
    setPlanOptions(planArray);
  }, [fundingData, broker]);

  useEffect(() => {
    let competitionArray = [];
    fundingData?.map((item) => {
      if (selectedOption?.value === item.id) {
        item?.challenges?.map((item) => {
          competitionArray.push({ value: item.id, label: item.name });
        });
      }
      setCompetitionOptions(competitionArray);
    });
  }, [selectedOption]);

  const CreateTradingAccount = async () => {
    if (!selectedIssueType) {
      dispatch(returnErrors("Please Select Issue Type", 400));
      return;
    }
    if (selectedBrand?.brand === "equity_edge") {
      if (isMt5Only && data?.broker !== "mt5") {
        dispatch(returnErrors("For Poland, only MT5 is allowed", 400));
        return;
      }
      if (isMatchTraderOnly && data?.broker !== "matchtrade") {
        dispatch(
          returnErrors(
            "Match-Trader is the only allowed platform for this country",
            400,
          ),
        );
        return;
      }
    }
    setIsSpinner(true);
    const response = await CreateTradingAccountReq(idToken, data);
    console.log("resb", response);
    if (response?.status < 399) {
      const accountNumber = response?.data.login_id; // "458891"
      const accountType = `${response?.data.plan_name} - $${response?.data?.challenge} - ${response?.data?.phase}`;

      // Helper to capitalize words
      const capitalizeWords = (str) =>
        str.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
      const formattedAccountType = capitalizeWords(accountType);

      dispatch(
        returnMessages(
          `Created Account Successfully\nEmail: ${userEmail}\nAccount Number: ${accountNumber}\nAccount Type: ${String(
            formattedAccountType,
          ).replace("_", " ")}`,
          201,
        ),
      );
      // dispatch(returnMessages("Created Account Successfully", 201));
    } else {
      let msg =
        response?.response?.data?.detail ||
        response?.response?.data[0] ||
        "Something went wrong";
      dispatch(returnErrors(msg, 400));
    }
    setIsSpinner(false);
  };

  const emailSelectorStyles = {
    ...customStyles,
    singleValue: (provided) => ({
      ...provided,
      color: "#000",
      fontWeight: 500,
      textTransform: "lowercase",
    }),
    option: (provided, state) => ({
      ...provided,
      textTransform: "lowercase",
    }),
  };

  let timeoutId = "";
  const handleOninputChange = (value, actionMeta) => {
    if (actionMeta?.action && actionMeta.action !== "input-change") {
      return;
    }
    if (typeof value === "string" && value.length > 0) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fetch(value);
      }, 1500);
    }
  };
  return (
    <>
      <div className="create_trading_account">
        <div className="create_header">
          <p>Create Trading Account</p>
        </div>
        <div className="create_trading_account_wrapper">
          <div className="input_form">
            {/* <div className="input_form-top">
              <div className="input_wrapper">
                <label htmlFor="accountName">Account name</label>
                <input
                  type="text"
                  name="accountName"
                  placeholder="account name"
                />
              </div>
              <div className="input_wrapper">
                <label htmlFor="password"> Password </label>
                <input type="text" name="password" placeholder="********" />
              </div>
            </div> */}
            <div className="input_form-mid">
              <div className="input_wrapper">
                <label htmlFor="Email">Email</label>
                <Select
                  isLoading={isLoading}
                  placeholder={"Search for a user"}
                  styles={emailSelectorStyles}
                  options={emailOpts}
                  className="email-selector"
                  classNamePrefix="react-select"
                  onInputChange={(value, actionMeta) =>
                    handleOninputChange(value, actionMeta)
                  }
                  onChange={handleUserChange}
                />
              </div>
            </div>
            <div className="input_wrapper">
              <label htmlFor="Country">Country</label>
              <div className="country_display_box">
                {isCountryLoading ? (
                  <CircularProgress size={20} />
                ) : userCountry ? (
                  <div className="country_info">
                    <span style={{ fontWeight: 500, color: "#000" }}>
                      {selectedCountryObj?.country || userCountry}
                    </span>
                  </div>
                ) : (
                  <span className="country_placeholder">
                    {data?.user ? "No country available" : "Select a user to view country"}
                  </span>
                )}
              </div>
            </div>
            <div className="input_wrapper">
              <label htmlFor="">Trading Platform</label>
              <Select
                className="plan_selector"
                options={brokerOptions}
                styles={customStyles}
                value={broker}
                isSearchable={false}
                isDisabled={selectedBrand?.brand === "crypto_edge"}
                onChange={(selectedOption) => {
                  setData((prev) => {
                    const { challenge, phase, ...rest } = prev;
                    return {
                      ...rest,
                      broker: selectedOption.value,
                    };
                  });
                  setBroker(selectedOption);
                  setSelectedOption(null);
                  setSelectedCompetition(null);
                  setPhase(null);
                }}
              />
            </div>
            <div className="input_form-btm">
              <div className="input_wrapper">
                <label htmlFor="">Plan Type</label>
                <Select
                  className="plan_selector"
                  options={planOptions}
                  styles={customStyles}
                  value={selectedOption}
                  onChange={handleSelectChange}
                  isSearchable={false}
                />
              </div>
              <div className="input_wrapper">
                <label htmlFor="">Account Size</label>
                <Select
                  className="plan_selector"
                  options={competitonOptions}
                  isSearchable={false}
                  styles={customStyles}
                  value={selectedCompetition}
                  onChange={(selectedOption) => {
                    setData((prev) => ({
                      ...prev,
                      challenge: selectedOption.value,
                    }));

                    handleSelectCompetitionChange(selectedOption);
                  }}
                />
              </div>
            </div>
            <div className="input_form-btm">
              <div className="input_wrapper">
                <label htmlFor="">Phase</label>
                <Select
                  styles={customStyles}
                  placeholder="Select a Phase"
                  classNamePrefix="react-select"
                  isSearchable={false}
                  options={
                    selectedBrand?.brand === "crypto_edge"
                      ? phaseCryptoOptions
                      : phaseOptions?.filter((item) => {
                          if (selectedOption?.label?.startsWith("1 Step")) {
                            return item.value !== "stage_2";
                          }
                          return true; // Ensure all other cases return true to include the item
                        })
                  }
                  value={phase}
                  isDisabled={
                    selectedOption?.label?.toLowerCase().includes("pro edge") ||
                    selectedOption?.label?.toLowerCase().includes("instant")
                  }
                  onChange={(selectedOption) => {
                    selectedOption.value === null
                      ? setPhase(null)
                      : setPhase(selectedOption);

                    setData((prev) => ({
                      ...prev,
                      phase: selectedOption.value,
                    }));
                  }}
                />
              </div>
              <div className="input_wrapper">
                <label htmlFor="">Issue Type</label>
                <Select
                  styles={customStyles}
                  placeholder="Select a Issue Type"
                  classNamePrefix="react-select"
                  isSearchable={false}
                  options={issueTypeOptions}
                  value={selectedIssueType}
                  onChange={(selectedOption) => {
                    console.log("selectedOption", selectedOption);
                    selectedOption.value === null
                      ? setSelectedIssueType(null)
                      : setSelectedIssueType(selectedOption);

                    setData((prev) => ({
                      ...prev,
                      issue_type: selectedOption.value,
                    }));
                  }}
                />
              </div>
            </div>

            <div
              onClick={() => CreateTradingAccount()}
              className="view_details_btn"
            >
              {isSpinner ? (
                <CircularProgress color="inherit" />
              ) : (
                "Create Account"
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateTradingAccount;
